import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import {
  ScopeOfPracticeEnum,
  SCOPE_OF_PRACTICE_ENUM_RECORD
} from '@umss/shared/utils';
import { UmssBadgeComponent } from '../badge/badge.component';
import { UmssTooltipDirective } from '../../directives/tooltip.directive';

/**
 * Component to display a badge based on scope of practice.
 * Shows abbreviated scope (e.g., "RN") with a tooltip showing the full name (e.g., "Registered Nurse").
 */
@Component({
  selector: 'umss-scope-of-practice-badge',
  standalone: true,
  imports: [UmssBadgeComponent, UmssTooltipDirective],
  template: `
    @if (scope) {
      <umss-badge
        [variant]="'secondary'"
        [label]="scope.toUpperCase()"
        [outlined]="true"
        [umssTooltip]="displayText"
        tooltipPosition="top"
        [size]="size"
      />
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UmssScopeOfPracticeBadgeComponent {
  private _scope: string = '';
  displayText: string = '';

  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input({ required: true }) set scope(value: ScopeOfPracticeEnum | string) {
    this._scope = value as string;

    this.displayText =
      SCOPE_OF_PRACTICE_ENUM_RECORD[value as ScopeOfPracticeEnum] || value;
  }
  get scope(): string {
    return this._scope;
  }
}
